let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lCGb1")).then(() => parcelRequire('lrWy4'));